<template>
  <div class="CMP" v-if="isSuccess || isOk || isError">
    <div>
      <div class="CMP-box">
        <img
          v-if="clientWidth > 768"
          src="https://staticdn.ht-s.cn/se/ciif/2022/common/dialog_h.png"
          alt="CMP-img1"
          srcset=""
        />
        <img
          v-if="clientWidth <= 768"
          src="https://staticdn.ht-s.cn/se/ciif/2022/common/dialog_h.png"
          alt="CMP-img1"
          srcset=""
        />
        <i class="close" @click="handleClose" v-ga="{'event':'trk','ec':'popup','ea':'close'}"></i>
        <div class="CMP0">

        </div>
        <!-- 已回答问题 -->
        <div class="CMP1" v-if="isSuccess">
          <img class="CMP_img" src="https://staticdn.ht-s.cn/se/ciif/2022/common/dialog_success.png" alt="">
          <p>
            您已回答过此问题
          </p>
          <div class="btn-box">
            <span class="CMP-btn"  @click="handleClose()">返回{{text}}</span>
          </div>
        </div>

        <!-- 回答正确 -->
        <div class="CMP2" v-if="isOk">
          <img class="CMP_img" src="https://staticdn.ht-s.cn/se/ciif/2022/common/dialog_ok.png" alt="">
          <div class="CMP_text">恭喜您，答题正确。</div>
          <p>
            感谢您参与2023年工博会{{text}}<br>小问答~
          </p>
          <div class="btn-box">
            <span class="CMP-btn" @click="handleClose()">返回{{text}}</span>
          </div>
        </div>

        <!-- 回答错误 -->
        <div class="CMP3" v-if="isError">
          <img class="CMP_img" src="https://staticdn.ht-s.cn/se/ciif/2022/common/dialog_error.png" alt="">
          <div class="CMP_text">很遗憾您回答错误！</div>
          <p>
            感谢您参与2023年工博会{{text}}<br>小问答~
          </p>
          <div class="btn-box">
            <span class="CMP-btns" :style="text === '直播'? 'width: 280px':''" @click="handleClose()">返回{{text}}</span>
            <span v-if="text !== '直播'" class="CMP-btn" @click="handleReset()">重新答题</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let nowDate = new Date();
export default {
  props: {
    isSuccess: {
      type: Boolean,
      value: false,
    },
    isOk: {
      type: Boolean,
      value: false,
    },
    isError: {
      type: Boolean,
      value: false,
    },
    text: {
      type: String,
      value: ''
    }
  },
  data() {
    return {
      Year: nowDate.getFullYear(),
    };
  },
  methods:{
    handleClose(){
      const obj = {
        event: "trk",
        ec: "popup",
        ea: "close",
        el: "close",
      };
      dataLayer.push(JSON.parse(JSON.stringify(obj)))
        this.$emit('handleClose')
    },
    handleReset() {
      this.$emit('handleReset')
    }
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>